import React from "react";
import "./ModalButtonsDisplay.scss";

const ModalButtonsDisplay = (props) => {
  return (
    <div className="modal-container-button">
      <p className="title-modal-container-button">{props.title}</p>
      <p>{props.text}</p>
      <div className="modal-button-container">
        <button onClick={props.deny} className="skip-button-general skip-button-deny">
          {props.denyText}
        </button>
        <button onClick={props.accept} className="skip-button-general skip-button-confirm">{props.acceptText}</button>
      </div>
    </div>
  );
};

export default ModalButtonsDisplay;
